import { render, staticRenderFns } from "./QuizesIndex.vue?vue&type=template&id=ee02683e"
import script from "./QuizesIndex.vue?vue&type=script&lang=js"
export * from "./QuizesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports